import React, { Component } from "react";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import TiebreakersDialog from "../../components/structure/TiebreakersDialog";
import TiebreakerDefaults from "../../constants/TiebreakerDefaults";

class TiebreakersContainer extends Component {
  state = {
    open: false,
    newTiebreakers: [],
    submitEnabled: false,
  };

  toggleDialog = () => {
    this.setState({
      open: !this.state.open,
      newTiebreakers: this.props.tiebreakers,
      submitEnabled: false,
    });
  };

  handleSwitch = (event, checked) => {
    // this.setState({
    //   applyHeadToHeadRecursively: !this.state.applyHeadToHeadRecursively,
    // });
    const tiebreakers = this.state.newTiebreakers.slice();

    const headToHeadIndex = tiebreakers.findIndex((t) => t.id === "headToHead");
    tiebreakers[headToHeadIndex]["applyRecursively"] = checked;
    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleDirectionToggle = (criteriumId, desc) => {
    const tiebreakers = this.state.newTiebreakers.slice();

    const criteriumIndex = tiebreakers.findIndex((t) => t.id === criteriumId);
    const criterium = { id: criteriumId, custom: true, desc: desc };
    tiebreakers[criteriumIndex] = criterium;
    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleDirectionToggleSub = (criteriumId, desc) => {
    const tiebreakers = this.state.newTiebreakers.slice();
    const headToHeadIndex = tiebreakers.findIndex((t) => t.id === "headToHead");
    const headToHead = tiebreakers[headToHeadIndex];
    const newSubCriteria = headToHead.subCriteria.slice();

    const criteriumIndex = newSubCriteria.findIndex(
      (t) => t.id === criteriumId
    );
    const criterium = { id: criteriumId, custom: true, desc: desc };
    newSubCriteria[criteriumIndex] = criterium;
    tiebreakers[headToHeadIndex]["subCriteria"] = newSubCriteria;

    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleAddCriterium = (criteriumId, custom = false) => {
    const tiebreakers = this.state.newTiebreakers.slice();
    const newTiebreaker = { id: criteriumId };
    if (custom) {
      newTiebreaker["custom"] = true;
    }
    if (criteriumId === "headToHead") {
      newTiebreaker["applyRecursively"] = true;
      if (this.props.useSets) {
        newTiebreaker["subCriteria"] = [
          { id: "points" },
          { id: "numMatchesWon" },
          { id: "setDifference" },
        ];
      } else {
        newTiebreaker["subCriteria"] = [
          { id: "points" },
          { id: "goalDifference" },
          { id: "goalsScored" },
        ];
      }
    }
    tiebreakers.push(newTiebreaker);
    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleDeleteCriterium = (criteriumId) => {
    let tiebreakers = this.state.newTiebreakers.slice();
    tiebreakers = tiebreakers.filter((t) => t.id !== criteriumId);
    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleAddSubCriterium = (criteriumId, custom = false) => {
    const tiebreakers = this.state.newTiebreakers.slice();

    const headToHeadIndex = tiebreakers.findIndex((t) => t.id === "headToHead");
    const headToHead = tiebreakers[headToHeadIndex];
    const newSubCriteria = headToHead.subCriteria.slice();
    newSubCriteria.push({ id: criteriumId, custom: custom });
    tiebreakers[headToHeadIndex] = {
      id: "headToHead",
      subCriteria: newSubCriteria,
      applyRecursively: headToHead.applyRecursively || false,
    };
    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleDeleteSubCriterium = (criteriumId) => {
    const headToHeadIndex = this.state.newTiebreakers.findIndex(
      (t) => t.id === "headToHead"
    );
    const headToHead = this.state.newTiebreakers.slice()[headToHeadIndex];
    const newSubCriteria = headToHead.subCriteria.filter(
      (s) => s.id !== criteriumId
    );
    const tiebreakers = this.state.newTiebreakers.slice();
    tiebreakers[headToHeadIndex] = {
      id: "headToHead",
      subCriteria: newSubCriteria,
      applyRecursively: headToHead.applyRecursively || false,
    };
    this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
  };

  handleSubmit = () => {
    let toUpdate = {};
    if (this.props.scoreTypeKey !== undefined) {
      toUpdate[`scoringTypes.${this.props.scoreTypeKey}.tiebreakers`] =
        this.state.newTiebreakers;
    } else {
      toUpdate = { tiebreakers: this.state.newTiebreakers };
    }
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate)
      .then(() => {
        this.toggleDialog();
      });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const tiebreakers = this.state.newTiebreakers
      .slice()
      .filter((t) =>
        t.custom
          ? (this.props.tournament.customPoints || {})[t.id] !== undefined
          : true
      );

    if (result.source.droppableId === "criteriumDrop") {
      const [removed] = tiebreakers.splice(result.source.index, 1);
      tiebreakers.splice(result.destination.index, 0, removed);
      this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
    } else if (result.source.droppableId === "subCriteriumDrop") {
      const headToHeadIndex = tiebreakers.findIndex(
        (t) => t.id === "headToHead"
      );
      const headToHead = tiebreakers[headToHeadIndex];
      const newSubCriteria = headToHead.subCriteria
        .slice()
        .filter((t) =>
          t.custom
            ? (this.props.tournament.customPoints || {})[t.id] !== undefined
            : true
        );
      const [removed] = newSubCriteria.splice(result.source.index, 1);
      newSubCriteria.splice(result.destination.index, 0, removed);
      tiebreakers[headToHeadIndex] = {
        id: "headToHead",
        subCriteria: newSubCriteria,
      };
      this.setState({ newTiebreakers: tiebreakers, submitEnabled: true });
    }
  };

  backToDefault = () => {
    let newTiebreakers = TiebreakerDefaults["0"].criteria;
    if (this.props.useSets) {
      newTiebreakers = TiebreakerDefaults["2"].criteria;
    }
    this.setState({ newTiebreakers: newTiebreakers, submitEnabled: true });
  };

  render() {
    let tiebreakers = this.state.newTiebreakers.filter((t) =>
      t.custom ? (this.props.tournament.customPoints || {})[t.id] : true
    );
    let tiebreakersAreDefault = true;
    let tiebreakerDefaultToCheck = TiebreakerDefaults["0"].criteria;
    if (this.props.useSets) {
      tiebreakerDefaultToCheck = TiebreakerDefaults["2"].criteria;
    }
    tiebreakerDefaultToCheck.forEach((t, i) => {
      const tb = tiebreakers[i];
      if (tb) {
        if (tb.id !== t.id) {
          tiebreakersAreDefault = false;
        } else if (tb.id === "headToHead") {
          t.subCriteria.forEach((s, x) => {
            const sc = tb.subCriteria[x];
            if (sc) {
              if (s.id !== sc.id) {
                tiebreakersAreDefault = false;
              }
            } else {
              tiebreakersAreDefault = false;
            }
          });
          if (t.subCriteria.length !== tb.subCriteria.length) {
            tiebreakersAreDefault = false;
          }
        }
      } else {
        tiebreakersAreDefault = false;
      }
    });
    if (tiebreakerDefaultToCheck.length !== tiebreakers.length) {
      tiebreakersAreDefault = false;
    }

    return (
      <div>
        <Button
          variant="outlined"
          color="default"
          onClick={this.toggleDialog}
          style={{ marginTop: 10, width: "100%" }}
        >
          {languages.tiebreakers.editRanking}
        </Button>
        <TiebreakersDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          tiebreakers={tiebreakers}
          useSets={this.props.useSets}
          handleAddCriterium={this.handleAddCriterium}
          handleDeleteCriterium={this.handleDeleteCriterium}
          handleAddSubCriterium={this.handleAddSubCriterium}
          handleDeleteSubCriterium={this.handleDeleteSubCriterium}
          handleSubmit={this.handleSubmit}
          submitEnabled={this.state.submitEnabled}
          onDragEnd={this.onDragEnd}
          tournament={this.props.tournament}
          handleDirectionToggle={this.handleDirectionToggle}
          handleDirectionToggleSub={this.handleDirectionToggleSub}
          tiebreakersAreDefault={tiebreakersAreDefault}
          backToDefault={this.backToDefault}
          handleSwitch={this.handleSwitch}
        />
      </div>
    );
  }
}

export default TiebreakersContainer;
